module.exports = __webpack_public_path__ + "static/media/cert_147.c2fba631.jpg";